export default {
  setLoading(state, info) {
    state.loading = info
  },
  setCanJoinAct(state, info) {
    state.canJoinAct = info
  },
  setCodeTime(state, info) {
    state.codeTime = info
  },
  setCodeSended(state, info) {
    state.codeSended = info
  },
  PUSH_CANCEL(state, payload) {
    state.cancelTokenArr.push(payload.cancelToken);
  },
  CLAER_CANCEL({ cancelTokenArr }) {

    cancelTokenArr.forEach(item => {
      item('路由跳转取消请求');
    });

    cancelTokenArr = [];
  },
  setHadRefreshLogin(state, info) {
    state.hadRefreshLogin = info
  },
  setEnrollStatus(state, info) {
    state.enrollStatus = info
  },
  setActName(state,info){
    state.actName = info
  },
  setActShareData(state,info){
    state.actShareData = info
  },
  setSecKillItem(state,info){
    state.seckillItem = info
  }
}